module.exports = __webpack_public_path__ + "img/stop_rectangle_fill.9e766ccb.svg";